<template>
    <v-container class="not-found mb-4">
        <h1 class="text-center display-4">404</h1>
        <p class="text-center display-2">Здесь ничего нет =(</p>
        <p class="text-center display-2">
            Вернитесь на 
            <router-link class="in-text-link"
                to="/" 
                exact 
                replace>
                главную страницу
            </router-link>
            <!-- <a class="link-style" href="/">главную страницу</a> -->
        </p>
    </v-container>
</template>

<script>
export default {}
</script>

<style scoped>
    .not-found {
        text-align: center;
    }
</style>